import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import MonogramColorOptions from "./monogram-color-options";

export default function MonogramStepColor({
  product,
  globalConfig,
  config,
  setConfig,
}) {
  const colors = [
    {
      colorKey: "color",
      availableColors: globalConfig.colors,
      selectedMessage: window.theme.localeStrings.monogram.text_color,
    },
  ];

  if (config.font?.hasShadow === "true") {
    colors.push({
      colorKey: "shadowColor",
      availableColors: globalConfig.shadowColors,
      selectedMessage: window.theme.localeStrings.monogram.shadow_color,
    });
  }

  return (
    <div className="monogram-config__colors">
      {colors.map(({ colorKey, availableColors, selectedMessage }) => (
        <MonogramColorOptions
          colorKey={colorKey}
          availableColors={availableColors}
          config={config}
          setConfig={setConfig}
          selectedMessage={selectedMessage}
        />
      ))}
    </div>
  );
}
